import React from 'react';
import CheckIcon from '@mui/icons-material/Check';
import { Skeleton } from '@material-ui/lab';

const MaterialItem = ({ material, isSelected, type, onSelect, loading }) => {
    if (loading) {
        return (
            <div className="material-card p-2 mb-2 border rounded border-secondary">
                <div className="d-flex align-items-start gap-3">
                    {/* Icon Skeleton */}
                    <div className="p-0">
                        <Skeleton variant="rect" width={40} height={40} className="rounded" />
                    </div>

                    {/* Content Skeleton */}
                    <div className="flex-grow-1">
                        {/* Title */}
                        <Skeleton variant="text" width="60%" height={24} className="mb-2" />

                        {/* Details Grid Match */}
                        <div className="d-flex flex-wrap gap-1">
                            {/* Column 1 */}
                            <div className="detail-column d-flex flex-column gap-1 w-50">
                                <Skeleton variant="text" width="80%" height={16} />
                                <Skeleton variant="text" width="60%" height={16} />
                            </div>
                            {/* Column 2 */}
                            <div className="detail-column d-flex flex-column gap-1 flex-grow-1">
                                <Skeleton variant="text" width="70%" height={16} />
                                <Skeleton variant="text" width="50%" height={16} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    //Actual Data Render
    return (
        <div
            key={material.id}
            onClick={() => onSelect(material)}
            data-cy={`material-item-${type}-${material.id}`}
            className={`material-card p-2 mb-2 border rounded cursor-pointer ${isSelected
                ? type === 'source'
                    ? 'selected-source'
                    : 'selected-target'
                : 'border-secondary'
                }`}
        >
            <div className="d-flex align-items-start gap-3">
                {/* Icon Box */}
                <div className={`rounded p-2 icon-box ${isSelected ? 'text-white' : 'bg-light'}`}>
                    {isSelected ? (
                        <CheckIcon className="check-icon" />
                    ) : (
                        <span className="check-icon material">📦</span>
                    )}
                </div>

                {/* Text Content */}
                <div className="flex-grow-1 text-start">
                    <h6 className="mb-1 material-name text-start">{material.item}</h6>
                    <div className="material-details d-flex flex-wrap gap-1 text-start">

                        {/* Left Detail Column */}
                        <div className="detail-column d-flex flex-column gap-1">
                            <div className="detail-item">
                                <span className="detail-label">Part No:</span>
                                <span className="detail-value part-no">{material.part_no || 'N/A'}</span>
                            </div>
                            <div className="detail-item">
                                <span className="detail-label">Unit Cost:</span>
                                <span className="detail-value">
                                    ${material.cost ?? 'N/A'}/{material.unit || 'N/A'}
                                </span>
                            </div>
                        </div>

                        {/* Right Detail Column */}
                        <div className="detail-column d-flex flex-column gap-1">
                            <div className="detail-item">
                                <span className="detail-label">Catalog:</span>
                                <span className="category-badge">{material.category_name || 'N/A'}</span>
                            </div>
                            <div className="detail-item">
                                <span className="detail-label">Category:</span>
                                <span className="detail-value">{material.manufacturer || 'N/A'}</span>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
};

export default MaterialItem;